import { c as _c } from "react/compiler-runtime";
import { useMediaQuery } from 'usehooks-ts';
import ArrowRight from '@/components/assets/icon_arrow_right.svg';
import ViverseWorldCard from '@/components/ViverseWorldCard';
import { useDraggingScroll } from '@/hooks/useDraggingScroll';
import { useScrollable } from '@/hooks/useScrollable';
import { Link } from '@/i18n/navigation';
import { cn } from '@/lib/utils';
import { getCardType } from '@/lib/viverse-world-card';
import { Owner, Room } from '@/services/cms';
type UserFollowingPublicRoomProps = {
  creator: Owner;
  rooms: Room[];
};
function UserUnlockedRoom(t0) {
  const $ = _c(25);
  const {
    rooms,
    creator
  } = t0;
  const stopScroll = useMediaQuery("(min-width: 1440px)");
  const {
    containerRef,
    canScrollLeft,
    canScrollRight
  } = useScrollable(300, stopScroll);
  const {
    bind,
    disableDrag,
    onMouseDown,
    onMouseUp
  } = useDraggingScroll(containerRef);
  const t1 = `/profile/${creator.community_user_id}`;
  let t2;
  if ($[0] !== creator.display_name) {
    t2 = <h2 className="header-5 text-vive-primary-20 max-md:text-base">{creator.display_name}</h2>;
    $[0] = creator.display_name;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowRight className="fill-vive-primary-20 h-5 w-5" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t2) {
    t4 = <Link href={t1} className="flex w-fit items-center gap-2">{t2}{t3}</Link>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== bind) {
    t5 = bind();
    $[6] = bind;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = !disableDrag && (canScrollLeft || canScrollRight);
  const t7 = !disableDrag && (canScrollLeft || canScrollRight);
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = cn("no-scrollbar flex w-full flex-col gap-6 max-lg:overflow-scroll max-lg:scroll-smooth md:gap-9", {
      "active:cursor-grabbing": t6,
      "cursor-grab": t7
    });
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== rooms) {
    t9 = rooms.map(_temp);
    $[11] = rooms;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t9) {
    t10 = <div className="flex gap-5 md:-mx-2 md:gap-2 lg:flex-wrap lg:gap-2">{t9}</div>;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== containerRef || $[16] !== onMouseDown || $[17] !== onMouseUp || $[18] !== t10 || $[19] !== t5 || $[20] !== t8) {
    t11 = <div {...t5} ref={containerRef} className={t8} onMouseDown={onMouseDown} onMouseUp={onMouseUp}>{t10}</div>;
    $[15] = containerRef;
    $[16] = onMouseDown;
    $[17] = onMouseUp;
    $[18] = t10;
    $[19] = t5;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t4) {
    t12 = <div className="flex-gap relative flex flex-col gap-6">{t4}{t11}</div>;
    $[22] = t11;
    $[23] = t4;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}
function _temp(room, index) {
  return <ViverseWorldCard className="max-w-[306px] min-w-[306px] lg:max-w-[322px] lg:min-w-[322px]" key={`followings-card-${room.id}-${index}`} data-room-id={room.id} info={room} hidePremiumBadge={false} cardType={getCardType(room.content_type)} />;
}
export default UserUnlockedRoom;